import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant'
import {
    Button
} from 'vant'
import officialAccountsDialog from '@/components/officialAccountsDialog/officialAccountsDialog.vue'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
import {
    getNewlyActivity
} from '@/models/common'
export default {
    name: viewName.pageNotFound,
    components: {
        Button,
        'oa-Dialog': officialAccountsDialog,
        appGuideDialog
    },
    props: {
        status: {
            type: Number,
            value: 1
        },
        // 所有规格
        // activity_status: {
        //     type: Number,
        //     value: 2
        // },
        // 门店id
        sstore_id: {
            type: String,
            value: ''
        }
    },
    data () {
        return {
            query_sstore_id: '', // 页面跳转传参
            newly_activity_data: {
                img: '',
                topic_id: ''
            },
            jumpType: 'home' // 跳转小程序页面
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin
        }),
    },
    created () {
    },
    activated () {

    },
    mounted () {
        this.setTitle()
        const { sstore_id } = this.$route.query
        this.query_sstore_id = sstore_id
        this.getNewData()
    },
    methods: {
        ...mapActions([
            'setAppClass',
        ]),
        setTitle () {
            this.$emit('setHeader', {
                title: '提示',
                showHeader: true,
                showLeft: false
            })
            this.setAppClass({
                isAppend: false,
                className: 'bgGreyColor'
            })
        },
        // goHomeUrl () {
        //     this.setAppClass({
        //         isAppend: true,
        //         className: 'appLoaded'
        //     })
        //     // 404页面跳转首页，清空路由
        //     this.$router.replace({ path: '/' })
        // },
        showTips () {
            // if (this.status === 1) {
            //     this.$refs.oaDialog && this.$refs.oaDialog.open()
            // } else if (this.status === 2) {
            //     this.$refs.appGuideDialog.open()
            // }
            this.$refs.appGuideDialog.open()
        },
        getNewData () {
            getNewlyActivity({ sstore_id: this.sstore_id || this.query_sstore_id })
                .then((res) => {
                    this.newly_activity_data = res
                }).catch(() => {})
        },
        goNewlyActivity () { // 跳转最近活动
            if (this.newly_activity_data.topic_id) {
                if (this.sstore_id || this.query_sstore_id) {
                    this.$router.push({
                        path: '/specialActivity',
                        query: {
                            topic_id: this.newly_activity_data.topic_id,
                            sstore_id: this.sstore_id || this.query_sstore_id,
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/marketingDetail',
                        query: {
                            topic_id: this.newly_activity_data.topic_id
                        }
                    })
                }
            }
        }

    },
    destroyed () {

    },
}
